import RatingListPage from "./pages/RatingListPage";

export const ratingsRoutes = (prefix = "ratings") => [
  {
    name: "RatingListPage",
    path: prefix,
    component: RatingListPage
  }
];
